import { render, staticRenderFns } from "./annualcollection.vue?vue&type=template&id=78595318&"
import script from "./annualcollection.vue?vue&type=script&lang=js&"
export * from "./annualcollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports